export enum Role {
    Admin = 'admin',
    Doctor = 'doctor',
    Expert = 'expert',
    Hospital = 'hospital'
  }